export default "__VITE_ASSET__B1_Gpz5z__"